<template>
  <div class="offline-business-order-list">
    <div class="toolbar">
      <el-form :inline="true" size="small">
        <el-form-item label="被保险人">
          <el-input
            v-model.trim="beneficiary"
            clearable
            placeholder="请输入被保险人"
            style="width: 220px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="投保人">
          <el-input v-model.trim="policyholder" clearable placeholder="请输入投保人" style="width: 220px" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="保单号">
          <el-input v-model.trim="policyNo" clearable placeholder="请输入保单号" style="width: 220px" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="起保时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
          />
        </el-form-item>
        <el-form-item label="发票接收状态">
          <el-select
            v-model="invoiceReceived"
            clearable
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option label="已收到" :value="true" />
            <el-option label="未收到" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="保险公司">
          <el-select
            v-model="insuranceType"
            filterable
            clearable
            placeholder="请选择保险公司"
            style="width: 220px"
          >
            <el-option
              v-for="item in insuranceCompanyList"
              :key="item.id"
              :label="item.name || item.insurance_company_name"
              :value="Number(item.id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select
            v-model="channelId"
            filterable
            clearable
            placeholder="全部渠道"
            style="width: 220px"
          >
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="channelLabel(item)"
              :value="Number(item.id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
          <el-button
            type="success"
            icon="el-icon-download"
            @click="handleExport"
            >导出 Excel</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-plus"
            @click="openOrderDialog('add')"
            >添加保单</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      stripe
      height="calc(100vh - 255px)"
      style="width: 100%"
    >
      <el-table-column
        prop="policyholder"
        label="投保人"
        width="180"
        fixed="left"
        show-overflow-tooltip
      />
      <el-table-column
        prop="beneficiary"
        label="被保险人"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column
        prop="insurance_company_name"
        label="保险公司"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column
        prop="policy_no"
        label="保单号"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column prop="province" label="省份" width="90" />
      <el-table-column prop="city" label="城市" width="90" />
      <el-table-column label="渠道" width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ rowChannelLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="起保时间" width="165">
        <template slot-scope="scope">{{
          formatDate(scope.row.effected_at || scope.row.effect_date)
        }}</template>
      </el-table-column>
      <el-table-column label="终保时间" width="165">
        <template slot-scope="scope">{{
          formatDate(scope.row.expired_at || scope.row.expire_date)
        }}</template>
      </el-table-column>
      <el-table-column label="保费(元)" width="110" align="right">
        <template slot-scope="scope">{{ money(scope.row.price) }}</template>
      </el-table-column>
      <el-table-column label="保单附件" width="100" align="center">
        <template slot-scope="scope"
          ><attachment-button :value="scope.row.policy_image_urls"
        /></template>
      </el-table-column>
      <el-table-column label="费率" width="90" align="right">
        <template slot-scope="scope">{{ rate(scope.row.rate) }}</template>
      </el-table-column>
      <el-table-column label="开票类型" width="120">
        <template slot-scope="scope">{{ invoiceTypeText(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="发票接收状态" width="130" align="center">
        <template slot-scope="scope">
          <attachment-button
            v-if="
              isInvoiceReceived(scope.row) &&
                parseUrls(scope.row.invoice_url).length
            "
            :value="scope.row.invoice_url"
            label="已收到，查看"
          />
          <span v-else>{{
            isInvoiceReceived(scope.row) ? "已收到" : "未收到"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tax_name"
        label="开票企业名称"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tax_no"
        label="纳税人识别号"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tax_address"
        label="注册地址"
        width="190"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tax_mobile"
        label="注册电话"
        width="130"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tax_bank"
        label="开户银行"
        width="160"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tax_bank_no"
        label="银行账号"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column label="营业执照" width="100" align="center">
        <template slot-scope="scope"
          ><attachment-button :value="scope.row.business_license_url"
        /></template>
      </el-table-column>
      <el-table-column
        prop="operator_mobile"
        label="业务员手机号"
        width="130"
      />
      <el-table-column label="预计营业收入" width="130" align="right">
        <template slot-scope="scope">{{
          tenThousand(scope.row.estimated_operating_income)
        }}</template>
      </el-table-column>
      <el-table-column label="单次赔偿限额" width="130" align="right">
        <template slot-scope="scope">{{
          tenThousand(scope.row.single_coverage)
        }}</template>
      </el-table-column>
      <el-table-column label="累计赔偿限额" width="130" align="right">
        <template slot-scope="scope">{{
          tenThousand(scope.row.total_coverage)
        }}</template>
      </el-table-column>
      <el-table-column label="免赔约定" width="100" align="center">
        <template slot-scope="scope"
          ><el-button
            type="text"
            @click="showContent('免赔约定', scope.row.deductible)"
            >查看</el-button
          ></template
        >
      </el-table-column>
      <el-table-column label="特别约定" width="100" align="center">
        <template slot-scope="scope"
          ><el-button
            type="text"
            @click="showContent('特别约定', scope.row.clause)"
            >查看</el-button
          ></template
        >
      </el-table-column>
      <el-table-column label="保险条款" width="100" align="center">
        <template slot-scope="scope"
          ><el-button
            type="text"
            @click="showContent('保险条款', scope.row.terms)"
            >查看</el-button
          ></template
        >
      </el-table-column>
      <el-table-column label="投保单附件" width="110" align="center">
        <template slot-scope="scope"
          ><attachment-button :value="scope.row.form_image_urls"
        /></template>
      </el-table-column>
      <el-table-column label="操作" width="320" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openOrderDialog('view', scope.row.id)"
            >查看</el-button
          >
          <el-button type="text" @click="handleRegisterClaim(scope.row)"
            >登记案件</el-button
          >
          <el-button type="text" @click="openOrderDialog('edit', scope.row.id)"
            >编辑</el-button
          >
          <el-button
            type="text"
            class="danger-button"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
          <el-button
            v-if="!isInvoiceReceived(scope.row)"
            type="text"
            @click="openInvoiceDialog(scope.row.id)"
            >收到发票</el-button
          >
          <el-button
            v-else
            type="text"
            @click="cancelInvoiceReceived(scope.row)"
            >撤销收到</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :current-page="pagination.page"
      :page-size="pagination.rows"
      :page-sizes="[10, 15, 20, 30, 50]"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <order-form-dialog
      :visible.sync="orderDialogVisible"
      :order-id="currentOrderId"
      :mode="orderDialogMode"
      @success="fetchList"
    />
    <invoice-dialog
      :visible.sync="invoiceDialogVisible"
      :order-id="currentOrderId"
      @success="fetchList"
    />
    <claim-editor
      :visible.sync="claimEditorVisible"
      mode="create"
      :risk-type="1"
      :policy-no="registerPolicyNo"
      @saved="fetchList"
    />
    <el-dialog
      :title="contentDialog.title"
      :visible.sync="contentDialog.visible"
      width="650px"
    >
      <div class="content-detail">
        {{ contentDialog.content || "暂无内容" }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import ExportJsonExcel from "js-export-excel";
import {
  deleteOfflineBusinessOrder,
  getOfflineBusinessChannelList,
  getOfflineBusinessInsuranceCompanyList,
  getOfflineBusinessOrderList,
  updateOfflineBusinessOrder
} from "@/api/offline-business-order";
import InvoiceDialog from "./components/InvoiceDialog.vue";
import OrderFormDialog from "./components/OrderFormDialog.vue";
import ClaimEditor from "../ClaimsManagement/components/ClaimEditor.vue";

const parseUrls = value => {
  if (!value) return [];
  if (Array.isArray(value))
    return value
      .map(item => (typeof item === "string" ? item : item && item.url))
      .filter(Boolean);
  if (typeof value === "object") return value.url ? [value.url] : [];
  const text = String(value).trim();
  try {
    return parseUrls(JSON.parse(text));
  } catch (error) {
    return text.indexOf(",") > -1
      ? text
          .split(",")
          .map(item => item.trim())
          .filter(Boolean)
      : [text];
  }
};

const AttachmentButton = {
  functional: true,
  props: {
    value: { type: [String, Array, Object], default: "" },
    label: { type: String, default: "查看" }
  },
  render(h, context) {
    const urls = parseUrls(context.props.value);
    if (!urls.length) return h("span", "-");
    return h("el-dropdown", { props: { trigger: "click" } }, [
      h("el-button", { props: { type: "text" } }, [context.props.label]),
      h(
        "el-dropdown-menu",
        { slot: "dropdown" },
        urls.map((url, index) =>
          h("el-dropdown-item", { key: url + index }, [
            h(
              "a",
              {
                attrs: {
                  href: url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              `文件 ${index + 1}`
            )
          ])
        )
      )
    ]);
  }
};

export default {
  name: "OfflineBusinessOrderList",
  components: {
    AttachmentButton,
    InvoiceDialog,
    OrderFormDialog,
    ClaimEditor
  },
  data() {
    return {
      loading: false,
      beneficiary: "",
      policyholder: "",
      policyNo: "",
      dateRange: [],
      invoiceReceived: "",
      insuranceType: "",
      channelId: "",
      channelList: [],
      insuranceCompanyList: [],
      tableData: [],
      pagination: { page: 1, rows: 15, total: 0 },
      orderDialogVisible: false,
      orderDialogMode: "add",
      invoiceDialogVisible: false,
      claimEditorVisible: false,
      currentOrderId: "",
      registerPolicyNo: "",
      contentDialog: { visible: false, title: "", content: "" }
    };
  },
  created() {
    this.fetchList();
    this.loadFilters();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await getOfflineBusinessOrderList({
          page: this.pagination.page,
          rows: this.pagination.rows,
          ...this.buildSearchParams()
        });
        this.tableData = (res && (res.rows || res.data)) || [];
        this.pagination.total = Number(
          (res && res.total) || this.tableData.length
        );
      } finally {
        this.loading = false;
      }
    },
    async loadFilters() {
      const results = await Promise.all([
        getOfflineBusinessChannelList(),
        getOfflineBusinessInsuranceCompanyList()
      ]);
      this.channelList =
        (results[0] && (results[0].rows || results[0].data)) || [];
      this.insuranceCompanyList =
        (results[1] && (results[1].rows || results[1].data)) || [];
    },
    buildSearchParams() {
      const params = {};
      if (this.beneficiary) params.beneficiary = this.beneficiary;
      if (this.policyholder) params.policyholder = this.policyholder;
      if (this.policyNo) params.policy_no = this.policyNo;
      if (this.dateRange && this.dateRange.length === 2) {
        params.begin_date = Math.floor(this.dateRange[0] / 1000);
        params.end_date = Math.floor(this.dateRange[1] / 1000) + 86399;
      }
      if (this.invoiceReceived !== "")
        params.is_invoice_received = this.invoiceReceived;
      if (this.insuranceType !== "")
        params.insurance_type = this.insuranceType;
      if (this.channelId !== "") params.channel_id = this.channelId;
      return params;
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    handleReset() {
      this.beneficiary = "";
      this.policyholder = "";
      this.policyNo = "";
      this.channelId = "";
      this.resetSearchValue();
      this.pagination.page = 1;
      this.fetchList();
    },
    resetSearchValue() {
      this.dateRange = [];
      this.invoiceReceived = "";
      this.insuranceType = "";
    },
    handleSizeChange(rows) {
      this.pagination.rows = rows;
      this.pagination.page = 1;
      this.fetchList();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchList();
    },
    openOrderDialog(mode, id) {
      this.orderDialogMode = mode;
      this.currentOrderId = id || "";
      this.orderDialogVisible = true;
    },
    handleRegisterClaim(row) {
      const policyNo = String(row.policy_no || "").trim();
      if (!policyNo) {
        this.$message.warning("该订单尚未录入保单号，无法登记案件");
        return;
      }
      this.registerPolicyNo = policyNo;
      this.claimEditorVisible = true;
    },
    openInvoiceDialog(id) {
      this.currentOrderId = id;
      this.invoiceDialogVisible = true;
    },
    async handleDelete(row) {
      await this.$confirm(
        `确定删除保单“${row.policy_no || row.id}”吗？`,
        "删除确认",
        { type: "warning" }
      );
      const res = await deleteOfflineBusinessOrder({ id: Number(row.id) });
      if (!res) return;
      this.$message.success("删除成功");
      if (this.tableData.length === 1 && this.pagination.page > 1)
        this.pagination.page -= 1;
      this.fetchList();
    },
    async cancelInvoiceReceived(row) {
      await this.$confirm("确定将该订单恢复为未收到发票吗？", "提示", {
        type: "warning"
      });
      const res = await updateOfflineBusinessOrder({
        id: Number(row.id),
        is_invoice_received: false
      });
      if (!res) return;
      this.$message.success("发票状态更新成功");
      this.fetchList();
    },
    async handleExport() {
      const res = await getOfflineBusinessOrderList(this.buildSearchParams());
      const rows = (res && (res.rows || res.data)) || [];
      const option = {
        fileName: "年保订单",
        datas: [
          {
            sheetData: rows.map(row => ({
              policyholder: row.policyholder,
              beneficiary: row.beneficiary,
              insurance_company_name: row.insurance_company_name,
              policy_no: row.policy_no,
              province: row.province,
              city: row.city,
              channel: this.rowChannelLabel(row),
              effected_at: this.formatDate(row.effected_at || row.effect_date),
              expired_at: this.formatDate(row.expired_at || row.expire_date),
              rate: this.rate(row.rate),
              price: this.money(row.price),
              invoice_type: this.invoiceTypeText(row),
              is_invoice_received: this.isInvoiceReceived(row)
                ? "已收到"
                : "未收到",
              tax_name: row.tax_name,
              tax_no: row.tax_no,
              tax_address: row.tax_address,
              tax_mobile: row.tax_mobile,
              tax_bank: row.tax_bank,
              tax_bank_no: row.tax_bank_no,
              operator_mobile: row.operator_mobile,
              estimated_operating_income: this.tenThousand(
                row.estimated_operating_income
              ),
              single_coverage: this.tenThousand(row.single_coverage),
              total_coverage: this.tenThousand(row.total_coverage)
            })),
            sheetName: "年保订单",
            sheetFilter: [
              "policyholder",
              "beneficiary",
              "insurance_company_name",
              "policy_no",
              "province",
              "city",
              "channel",
              "effected_at",
              "expired_at",
              "rate",
              "price",
              "invoice_type",
              "is_invoice_received",
              "tax_name",
              "tax_no",
              "tax_address",
              "tax_mobile",
              "tax_bank",
              "tax_bank_no",
              "operator_mobile",
              "estimated_operating_income",
              "single_coverage",
              "total_coverage"
            ],
            sheetHeader: [
              "投保人",
              "被保险人",
              "保险公司",
              "保单号",
              "省份",
              "城市",
              "渠道",
              "起保时间",
              "终保时间",
              "费率",
              "保费",
              "开票类型",
              "是否收到发票",
              "开票企业名称",
              "纳税人识别号",
              "注册地址",
              "注册电话",
              "开户银行",
              "银行账号",
              "业务员手机号",
              "预计营业收入",
              "单次赔偿限额",
              "累计赔偿限额"
            ]
          }
        ]
      };
      new ExportJsonExcel(option).saveExcel();
    },
    showContent(title, content) {
      this.contentDialog = { visible: true, title, content };
    },
    parseUrls,
    isInvoiceReceived(row) {
      return (
        row.is_invoice_received === true ||
        String(row.is_invoice_received) === "true" ||
        Number(row.is_invoice_received) === 1
      );
    },
    formatDate(value) {
      if (!value) return "-";
      const timestamp = /^\d{10}$/.test(String(value))
        ? Number(value) * 1000
        : value;
      const date = dayjs(timestamp);
      return date.isValid() ? date.format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    money(value) {
      return value === "" || value == null
        ? "-"
        : (Number(value) / 100).toFixed(2);
    },
    rate(value) {
      return value === "" || value == null ? "-" : `${Number(value) / 10000}%`;
    },
    tenThousand(value) {
      return value === "" || value == null ? "-" : `${Number(value) / 10000}万`;
    },
    invoiceTypeText(row) {
      if (Number(row.vat_invoice_open) === 2) return "不开票";
      if (Number(row.vat_invoice_open) === 4) return "待定";
      if (Number(row.vat_invoice_open) !== 1) return "-";
      return Number(row.vat_invoice_type) === 2 ? "开票-专票" : "开票-普票";
    },
    channelLabel(item) {
      const name = item.name || item.realname || item.channel_name || "";
      return item.alias ? `${name}（${item.alias}）` : name;
    },
    rowChannelLabel(row) {
      const name = row.channel_name || row.channel || "";
      return row.channel_alias || row.alias
        ? `${name}（${row.channel_alias || row.alias}）`
        : name || "-";
    }
  }
};
</script>

<style lang="less" scoped>
.offline-business-order-list {
  min-width: 0;
}

.toolbar {
  margin-bottom: 12px;
}

.toolbar /deep/ .el-form-item {
  margin-bottom: 10px;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

.danger-button {
  color: #f56c6c;
}

.content-detail {
  min-height: 100px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.7;
}

/deep/ .el-dropdown-menu__item a {
  display: block;
  color: #606266;
  text-decoration: none;
}
</style>
